import { IModalDescription, ViewVariant } from '@cp/shared/modal';
import { FeedbackEditProps } from '../ui/feedbackEditModal';

export const FEEDBACK_EDIT_MODAL: IModalDescription<FeedbackEditProps> = {
  nss: 'FEEDBACK_EDIT_MODAL',
  loader: () => import('../ui/feedbackEditModal').then((module) => module.FeedbackEditModal),
  layout: {
    desktop: ViewVariant.Dialog,
    mobile: ViewVariant.DrawerBottom,
  },
};
